import google from '../../assets/h_images/goog.jpg'
import alibaba from '../../assets/h_images/alibaba.jpg'
import amazon from '../../assets/h_images/amazon.jpg'
import telstra from '../../assets/h_images/telstra.jpg'
import snap from '../../assets/h_images/snap.jpg'
import portfolio from '../../assets/h_images/port.jpg'
import proessay from '../../assets/h_images/pro.jpg'
import moba from '../../assets/h_images/moba.jpg'
import arybba from '../../assets/h_images/arybba.jpg'
import zoom from '../../assets/h_images/zoom.jpg'

const data_projects = [
    {
        name: 'Google Cloud Hacking',
        image: google,
        // deployed_url: 'https://covid-19-tracker-by-sumit.web.app/',
        // github_url: 'https://github.com/Dey-Sumit/covid-19-tracker',
        category: ['hacking']
    },

    {
        name: 'Alibaba Cloud Hacking',
        image: alibaba,
        // deployed_url: 'https://dev-talks.herokuapp.com/',
        // github_url: 'https://github.com/Dey-Sumit/Dev-talks',
        category: ['hacking']
    },

    {
        name: 'Amazon Google Cloud Hacking',
        image: amazon,
        // deployed_url: 'https://sumit-chat.netlify.app/',
        // github_url: 'https://github.com/Dey-Sumit/chat-app-socket.io-react-node',
        category: ['hacking']
    },

    {
        name: 'Tesltra Cloud Hacking',
        image: telstra,
        // deployed_url: 'http://sumaxtweetme.pythonanywhere.com/',
        // github_url: 'https://github.com/Dey-Sumit/tweetme',
        category: ['hacking']
    },

    {
        name: 'Zoom Hacking',
        image: zoom,
        // deployed_url: 'http://sumaxtweetme.pythonanywhere.com/',
        // github_url: 'https://github.com/Dey-Sumit/tweetme',  
        category: ['hacking']
    },

    {
        name: 'Snap Courier Management',
        image: snap,
        deployed_url: '!#',
        category: ['website']
    },

    {
        name: 'Website Portfolio',
        image: portfolio,
        deployed_url: 'https://zealous-golick-25fb06.netlify.app/',
        category: ['website']
    },

    {
        name: 'Proessayhelper',
        image: proessay,
        deployed_url: 'https://proessayhelp.de',
        category: ['website']
    },

    {
        name: 'Moba 5v5 Game Dev',
        image: moba,
        deployed_url: '!#',
        github_url: '!#',
        category: ['gamedev']
    },

    {
        name: 'Arybba Food Delivery',
        image: arybba,
         deployed_url: 'https://arybba.com',
        // github_url: 'https://github.com/Dey-Sumit/Blinking_Bubbles',
        category: ['webdev']
    }
]

export default data_projects;